export * from "ce/sagas/DrawDBSagas";
import {
  fetchDrawDBGroupsSaga,
  fetchDrawDBAppsSaga,
  createDrawDBGroupSaga,
  createDrawDBSaga,
  editDrawDBSaga,
  fetchDrawDBAppSaga,
  deleteDrawDBAppSaga,
  deleteDrawDBGroupSaga,
  updateDrawDBGroupSaga,
  exportDrawDBAppSaga,
  importDrawDBAppSaga,
  inviteUsersToDrawDBGroupSaga,
  fetchDrawDBGroupUsersSaga,
  deleteDrawDBGroupMemberSaga,
  fetchDrawDBPermissionGroupsSaga,
} from "ce/sagas/DrawDBSagas";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import { all, takeLatest } from "redux-saga/effects";

export default function* drawDBSagas() {
  yield all([
    takeLatest(
      ReduxActionTypes.FETCH_DRAW_DB_GROUPS_INIT,
      fetchDrawDBGroupsSaga,
    ),
    takeLatest(ReduxActionTypes.FETCH_DRAW_DB_APPS_INIT, fetchDrawDBAppsSaga),
    takeLatest(
      ReduxActionTypes.CREATE_DRAW_DB_GROUP_INIT,
      createDrawDBGroupSaga,
    ),
    takeLatest(
      ReduxActionTypes.UPDATE_DRAW_DB_GROUP_INIT,
      updateDrawDBGroupSaga,
    ),
    takeLatest(ReduxActionTypes.CREATE_DRAW_DB_INIT, createDrawDBSaga),
    takeLatest(ReduxActionTypes.FETCH_DRAW_DB_APP_INIT, fetchDrawDBAppSaga),
    takeLatest(ReduxActionTypes.EDIT_DRAW_DB_INIT, editDrawDBSaga),
    takeLatest(ReduxActionTypes.DELETE_DRAW_DB_APP_INIT, deleteDrawDBAppSaga),
    takeLatest(ReduxActionTypes.DELETE_DRAW_DB_GROUP_INIT, deleteDrawDBGroupSaga),
    takeLatest(ReduxActionTypes.EXPORT_DRAW_DB_APP_INIT, exportDrawDBAppSaga),
    takeLatest(ReduxActionTypes.IMPORT_DRAW_DB_APP_INIT, importDrawDBAppSaga),
    takeLatest(ReduxActionTypes.INVITE_USERS_TO_DRAW_DB_GROUP_INIT, inviteUsersToDrawDBGroupSaga),
    takeLatest(ReduxActionTypes.FETCH_DRAW_DB_GROUP_USERS_INIT, fetchDrawDBGroupUsersSaga),
    takeLatest(ReduxActionTypes.DELETE_DRAW_DB_GROUP_MEMBER_INIT, deleteDrawDBGroupMemberSaga),
    takeLatest(ReduxActionTypes.FETCH_DRAW_DB_PERMISSION_GROUPS_INIT, fetchDrawDBPermissionGroupsSaga),
  ]);
}
